import { useApi } from '@/shared/api/http';

export const useTokenService = () => {
  const api = useApi();

  const getBKeyToken = async <T>() => {
    return await api.post<T>('b-key');
  };

  return {
    getBKeyToken,
  };
};
